<template>
    <div>
        <section class="m-content m-content-full align-items-center complaint">
            <div class="gate_center col">
                <div class="row  justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8 card--tab__title">
                        <h4 class="pull-left">
                            Talk to us about your complaint
                        </h4>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-lg-8 col-md-11 col-xs-12 col-sm-12">
                        <div class="widget">
                            <alert-box
                                    v-if="showAlert"
                                    :type="alert.type"
                                    :title="alert.title"
                                    :message="alert.message"
                                    @dismiss-alert="dismissAlert"/>
                            <div class="p-5">
                                <div class="d-flex justify-content-center my-4 mobile-view-margin">
                                    <div class="col-12">
                                        <h5 class="input--hint">
                                            Subject
                                            <a
                                                    href
                                                    @click.prevent
                                                    flow="down"
                                                    tooltip="Select what best describes your issue"
                                            >
                                                <img alt
                                                     src="../../../../static/media/demo/default/img/misc/info.png"/>
                                            </a>
                                        </h5>
                                        <div class="material--input--group m--margin-top-10">
                                            <select class="form-control m-input" v-model="complaint.subject">
                                                <option v-for="item in suggestedSubjects" :value="item.value"
                                                        :key="item.key">
                                                    {{item.value }}
                                                </option>
                                            </select>
                                            <span class="highlight"></span>
                                            <span class="bar"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center my-4 mobile-view-margin">
                                    <div class="col-12">
                                        <h5 class="input--hint">
                                            Tell us about your issue
                                        </h5>
                                        <div class="material--input--group m--margin-top-10">
                                                <textarea
                                                        title="Description"
                                                        type="text"
                                                        id="description"
                                                        v-model="complaint.description"
                                                >
                                                </textarea>
                                            <span class="highlight"></span>
                                            <span class="bar"></span>
                                            <label for="description">Description</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-center mt-4 mobile-view-margin">
                                    <div class="col-12">
                                        <label for="complaint-file-upload" class="cursor-pointer input--hint">
                                            <i class="icon fa fa-cloud"></i>
                                            Attach files
                                        </label>
                                        <p>Each of your file(s) can be up to {{maxUpload}} in size.</p>
                                        <input id="complaint-file-upload" class="d-none" ref="file" type="file" multiple
                                               @change="uploadFile"/>
                                    </div>
                                </div>

                                <div class="d-flex mb-4 mobile-view-margin">
                                    <div class="col-6">
                                        <div>
                                            <p v-for="upload in complaint.fileUploads" :key="upload.id">
                                                {{upload.name}}
                                                <button type="button" class="close cursor-pointer"
                                                        @click="deleteFile(upload.id)">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="widget__footer text-center m--margin-bottom-30">
                                    <button :disabled="isFormNotValid" class="btn btn-primary mx-3"
                                            @click="processCompliant">Submit
                                    </button>
                                    <button class="btn mx-3"
                                            @click="resetComplaintData">Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
  import {sendComplaint, sendFileUpload} from './../../../api/complaint/complaintService'
  import AlertBox from './../../../components/AlertBox'

  const MAX_FILE_SIZE = 20e6;
  const MB_DENOMINATOR = 1e6;

  export default {
    components: {
      AlertBox
    },
    data: () => ({
      complaint: {
        subject: null,
        description: null,
        fileUploads: []
      },
      showAlert: false,
      alert: {
        title: "",
        message: "",
        type: ""
      },
      suggestedSubjects: [
        {key: "Account Activation", value: "Account Activation"},
        {key: "Account Deactivation", value: "Account Deactivation"},
        {key: "Airtime", value: "Airtime"},
        {key: "App Issues", value: "App Issues"},
        {key: "Bank statement", value: "Bank statement"},
        {key: "Bill Payment", value: "Bill Payment"},
        {key: "BVN", value: "BVN"},
        {key: "Card Queries", value: "Card Queries"},
        {key: "Card Statement", value: "Card Statement"},
        {key: "Credit Bureau", value: "Credit Bureau"},
        {key: "Debit", value: "Debit"},
        {key: "Disbursement", value: "Disbursement"},
        {key: "Fraud", value: "Fraud"},
        {key: "Funds Transfer", value: "Funds Transfer"},
        {key: "General Inquiries", value: "General Inquiries"},
        {key: "Letter of non-indebtedness", value: "Letter of non-indebtedness"},
        {key: "Loan", value: "Loan"},
        {key: "Loan Repayment", value: "Loan Repayment"},
        {key: "Investment", value: "Investment"},
        {key: "Profile Update", value: "Profile Update"},
        {key: "Refund", value: "Refund"},
        {key: "Selfie Issues", value: "Selfie Issues"},
        {key: "Wallet", value: "Wallet"},
        {key: "Others", value: "Others"},
      ],
      maxUpload: `${MAX_FILE_SIZE / MB_DENOMINATOR}MB`
    }),
    computed: {
      isFormNotValid() {
        return !(this.complaint.subject && this.complaint.description);
      },
      userData() {
        return this.$store.state.Auth.user_data
      }
    },
    methods: {
      resetComplaintData() {
        this.complaint = {
          subject: null,
          description: null,
          fileUploads: []
        };
      },
      displayAlertBox(type, title, message) {
        this.alert = {
          type,
          title,
          message
        };
        this.showAlert = true;
      },
      dismissAlert() {
        this.showAlert = false;
      },
      processCompliant() {
        this.$store.dispatch('loader', true);
        const data = {
          cf: {
            cf_customer_identifier: "Client ID",
            cf_identifier: this.userData.clientId,
            cf_email_title: this.complaint.subject
          },
          departmentId: "337222000000006907",
          contactName: `${this.userData.firstname} ${this.userData.lastname}`,
          subject: this.complaint.subject,
          email: this.userData.email,
          description: this.complaint.description,
          classification: this.complaint.subject,
          uploads: this.complaint.fileUploads.map(upload => upload.id)
        };

        sendComplaint(data).then(response => {
          this.displayAlertBox("info", "Your complaint is successfully logged.", `You will be contacted via an email once it is resolved.`);
          this.resetComplaintData();
        }).catch(error => {
          this.displayAlertBox("danger", "Error:", "An error occurred while attempting to send your request, Please try again later");
        }).finally(() => {
          this.$store.dispatch('loader', false)
        })
      },
      async uploadFile() {
        const files = this.$refs.file.files;
        const uploadedFiles = [];

        for (let file of files) {
          if (file.size > MAX_FILE_SIZE) {
            this.displayAlertBox("danger", "Error:", `Cannot upload file greater than ${this.maxUpload}`);
            return;
          }
        }

        try {
          this.$store.dispatch('loader', true);
          for (let file of files) {
            const response = await sendFileUpload(file);
            uploadedFiles.push(response);
          }
          this.complaint.fileUploads.push(...uploadedFiles);
        } catch (err) {
          this.displayAlertBox("danger", "Error:", "unable to upload the selected file(s)");
        } finally {
          this.$refs.file.value = '';
          this.$store.dispatch('loader', false)
        }
      },
      deleteFile(uploadId) {
        const uploads = [...this.complaint.fileUploads];
        const searchedFileIndex = uploads.findIndex(upload => upload.id === uploadId);
        if (searchedFileIndex > -1) {
          uploads.splice(searchedFileIndex, 1);
          this.complaint.fileUploads = uploads;
        }
      }
    }
  }
</script>
